import React from "react";
import axios from "axios";
import qs from "qs";
import {TableReport} from "./table";
import {show_loader} from "./functions";
import {OrganizationData} from "../interface";
declare var organization_data:OrganizationData;

export class OrgOrders extends React.Component<any, any> {
    constructor(props:any) {
        super(props);
    }

    componentDidMount() {
        this.getOrganizationOrders( 'init' );
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if( prevProps.currOrganization !== this.props.currOrganization ) {
            this.getOrganizationOrders( 'init' );
        }
    }

    getOrganizationOrders( table_req:string='init' ) {
        if( this.props.currOrganization === 0 ) return;
        show_loader(true);

        axios.post( organization_data.admin_ajax, qs.stringify(  {
            action: 'fr_order_report',
            req_nonce: organization_data.req_nonce,
            org_id: this.props.currOrganization,
            table_req: table_req
        })).then( response => {
            if( response ) {
                if( response.data && response.data.success ) {
                    console.log( response );
                }
            }
        } ).catch( error => {
            console.error( 'Error', error );
        } ).finally(() => {
            show_loader(false);
        });
    }

    render() {
        const table_columns = ["Order", "Date", "Status", "Total"];
        const table_rows = [
            {
                "order": 133,
                "date": "June 1, 2023",
                "status": "Processing",
                "total": "$1.00",
            },
            {
                "order": 133,
                "date": "June 1, 2023",
                "status": "Processing",
                "total": "$1.00",
            },
            {
                "order": 133,
                "date": "June 1, 2023",
                "status": "Processing",
                "total": "$1.00",
            },
        ];
        return (
            <div>
                <TableReport table_columns={table_columns} table_rows={table_rows}/>
            </div>
        )
    }
}